import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';
import { ApiService } from '../../shared/services/api.service';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class VerificationGuard implements CanActivate {
	constructor(private router: Router, private auth: AuthService, private api: ApiService) {}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (!this.auth.user() || (this.auth.user() && this.auth.user()['phone'] && this.auth.user()['verified'] === '1')) {
			return true;
		} else {
			const profileFormData: FormData = new FormData();
			profileFormData.append('lang', next['queryParams']['lang'] ? next['queryParams']['lang'] : 'ku');
			profileFormData.append('userID', this.auth.user()['userID']);

			return this.api.profile(profileFormData).pipe(
				map((res) => {
					if (res['status'] === '1') {
						this.auth.login(
							res['response']['userID'],
							res['response']['name'],
							res['response']['phone'],
							res['response']['verified'],
							this.auth.user()['token'],
							res['response']['userType']
						);

						if (res['response']['verified'] === '1' && res['response']['phone']) {
							return true;
						} else if (res['response']['verified'] === '0' && res['response']['phone'] && res['response']['userType'] === '0') {
							return this.router.createUrlTree(['/user/' + this.auth.user()['userID'] + '/confirm-otp']);
						} else if (res['response']['verified'] === '0' && res['response']['userType'] === '1' && res['response']['phone']) {
							return this.router.createUrlTree(['/dealer/' + this.auth.user()['userID'] + '/update-profile']);
						} else {
							return this.router.createUrlTree(['/user/' + this.auth.user()['userID'] + '/process'], {
								queryParams: {
									subject: 'phone',
								},
							});
						}
					} else {
						this.auth.logout();
						return this.router.createUrlTree(['/login']);
					}
				})
			);
		}
	}
}
